import { useNavigate, useParams } from 'react-router-dom';
import { IParams } from '../../../model/shared/IParams';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../store/rootReducer';
import { Step1 } from './components/Step1';
import { Step2 } from './components/Step2';
import { Step3 } from './components/Step3';
import { Step4 } from './components/Step4';
import { useCallback } from 'react';
import * as React from 'react';
import { StepperType } from '../brand';
import { getCorrectRegisterEmployeeText, getCorrectRegisterStepper } from '../../../shared/functions/Functions';
import { useSearchQuery } from '../../../shared/hooks/useSearchQuery';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

export const RegisterEmployee = () => {
    const navigate = useNavigate();
    const { stepId } = useParams<keyof IParams>();
    const stepIdNumber = Number(stepId);
    const { t } = useTranslation();
    const token = useSearchQuery('token') as string;
    const handleBackStep = () => {
        navigate(`/brand/employee/register/${stepIdNumber - 1}?token=${token}`);
    };

    const savedData = useSelector((state: IAllStates) => state.registration);

    const step: StepperType = {
        1: (
            <GoogleReCaptchaProvider reCaptchaKey={process.env.VITE_RECAPTCHA_SITE_KEY as string}>
                <Step1 stepIdNumber={stepIdNumber} handleBackStep={handleBackStep} />
            </GoogleReCaptchaProvider>
        ),
        2: <Step2 stepIdNumber={stepIdNumber} handleBackStep={handleBackStep} />,
        3: <Step3 stepIdNumber={stepIdNumber} handleBackStep={handleBackStep} />,
        4: <Step4 stepIdNumber={stepIdNumber} handleBackStep={handleBackStep} />,
    };

    const CurrentStep = useCallback(() => {
        return step[stepIdNumber];
    }, [stepIdNumber]);

    return (
        <>
            <div className="row">
                {getCorrectRegisterStepper('registerEmployee', `${stepIdNumber}`)}
                <div className="col-12">
                    <h3>{getCorrectRegisterEmployeeText(`${stepIdNumber}`, t)?.title}</h3>
                    <p className="text-black-50 mb-4">
                        {getCorrectRegisterEmployeeText(`${stepIdNumber}`, t, savedData?.email)?.description}
                    </p>
                </div>
            </div>
            <div className="row w-100">
                <CurrentStep />
            </div>
        </>
    );
};
